import React, { Component } from 'react'
import { RadioGroup } from 'react-radio-group'
import { getFirstFocusableScopedElement } from 'utilities'
import { Attribute } from './Attribute'
import shortid from 'shortid'
import MASKS from '../Wizard2/masks'

export default class MaskEditor extends Component {
	constructor(props) {
		super(props)
		this.name = shortid.generate()
		this.state = {
			selected: props.field.mask[0] ? props.field.mask[0].fn : '',
			props: this.buildMaskObject(props),
			allowedMasks: props.field.allowedMasks
		}
	}
	buildMaskObject = props => {
		let maskProps = {};
		if (props.field.mask[0]) {
			Object.keys(MASKS[props.field.mask[0].fn].props).forEach(propId => {
				maskProps[propId] = { ...MASKS[props.field.mask[0].fn].props[propId], value: (props.field.mask[0].props || {})[propId] }
			})
		}
		return maskProps
	}
	clearState = () => {
		this.setState({
			selected: this.props.field.mask[0] ? this.props.field.mask[0].fn : '',
			props: this.buildMaskObject(this.props)
		})
	}
	setMaskValue = fn => {
		this.setState({
			selected: this.state.selected === fn ? '' : fn,
			props: MASKS[fn].props
		})
		const firstElement = getFirstFocusableScopedElement(".attribute-container")
		if (firstElement) {
			firstElement.focus()
		}
	}
	saveRules = () => {
		let newProps = {}
		Object.keys(this.state.props).forEach(propId => {
			newProps[propId] = this.state.props[propId].value
		})
		this.props.handleChange(
			'mask',
			this.state.selected !== '' ? [{ fn: this.state.selected, props: newProps }] : []
		)
	}
	setPropValue = (name, value) => {
		this.setState(state => ({
			props: { ...state.props, [name]: { ...state.props[name], value } }
		}))
	}
	render() {
		const { disabled, leftAlign } = this.props;
		const { selected, props, allowedMasks } = this.state;
		return (
			<div className="validation-editor">
				<div className="row">
					<div className="col-6 rule-container">
						<RadioGroup
							name={this.name}
							selectedValue={selected}
							className={'radio-group ' + (disabled ? 'disabled' : '')}
							onChange={this.setMaskValue}
						>
							<div>
								<div role="tablist" aria-label="Input Mask Options" aria-orientation="vertical">
									{allowedMasks.map((maskId, i) => {
										return (
											<div aria-selected={selected === MASKS[maskId].fn} role="tab" >
												<OptionRow
													leftAlign={leftAlign}
													disabled={disabled}
													{...MASKS[maskId]}
													selected={selected === MASKS[maskId].fn}
													onChange={this.setMaskValue}
													key={maskId}
												/>
											</div>
										)
									})}
								</div>
							</div>
						</RadioGroup>
					</div>
					<div className="attribute-container col-6">
						<div className="no-outline" tabIndex="0" role="tabpanel">
							{
								selected !== "" && props ? (Object.keys(props).length === 0 ?
									<div className="options-message">
										This mask has no additional options.
										</div>
									:
									Object.keys(props).map(propId => {
										let prop = props[propId]
										return (
											<div>
												<Attribute
													label={prop.label}
													type={prop.type}
													name={propId}
													value={prop.value}
													maxValue={prop.maxValue}
													minValue={prop.minValue}
													step={prop.step}
													handleChange={this.setPropValue}
													key={propId}
												/>
											</div>)
									})
								) : null
							}
						</div>
					</div>
				</div>
			</div>
		)
	}
}

class OptionRow extends Component {
	constructor() {
		super()
		this.name = shortid.generate()
	}
	setMaskValue = () => {
		this.props.onChange(this.props.fn)
	}
	handleKeyDown = (e) => {
		if (e.keyCode === 13 || e.keyCode === 32) {
			this.setMaskValue()
		}
	}
	render() {
		const { leftAlign, name, selected } = this.props
		return (
			<div tabIndex="0" onKeyDown={this.handleKeyDown}
				className={
					'custom-focus ' +
					'option-wrapper rule ' +
					(leftAlign ? 'left-align ' : ' ') +
					(selected ? 'checked ' : '')
				}
				onClick={this.setMaskValue}
			>
				<label
					className="field-label radio-label rule-name"
					htmlFor={this.name}
				>
					{name}
				</label>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/Designer2/MaskEditor.js